import NxAbstractRequest from '@jswork/next-abstract-request';
import '../alo7Api';

export default nx.declare({
  extends: NxAbstractRequest,
  methods: {
    request(inMethod: string, inUrl: string, inData: any, inOptions: any) {
      const body =
        inMethod === 'get' ? null : JSON.stringify(JSON.parse(inData).body);
      // @ts-ignore
      return window.alo7Api.fetch(inUrl, {
        method: inMethod.toLocaleUpperCase(),
        body,
        ...inOptions,
      });
    },
  },
});
